<template>
	<div class="containerDebitDetail">
		<!--        <div class="header-debits">-->
		<!--            <i @click="$router.push({name: 'AccordionTabs'})" class="fas fa-times"/>-->
		<!--        </div>-->
		<!--        <h3>{{divida.loj_fantasia}}</h3>-->

		<h4>Dados da empresa</h4>
		<div class="infos-row">
			<div class="infos">
				<h6>Razão social</h6>
				<h2>{{ divida.loj_razao_social }}</h2>
			</div>
			<div class="infos">
				<h6>Nome fantasia</h6>
				<h2>{{ divida.loj_razao_social }}</h2>
			</div>
			<div class="infos">
				<h6>CNPJ</h6>
				<h2>{{ cnpjMask(divida.loj_cpf_cnpj) }}</h2>
			</div>
		</div>
		<div style="display: flex; justify-content: space-between; align-items: center">
			<h4 style="text-align: left">PARCELAS</h4>
			<h4 style="text-align: right">CONTRATO ---</h4>
		</div>
		<div class="infos-row parcelas-box">
			<table class="table-parcelas">
				<tr>
					<th>Parcela</th>
					<th>Vencimento</th>
					<th>Dias em atraso</th>
					<th>Valor</th>
				</tr>
				<tr v-for="parcela in orderParelas">
					<td>{{ parcela.par_prestacao === "0" ? "À vista" : parcela.par_prestacao }}</td>
					<td>{{ parcela.par_vencimento }}</td>
					<td>---</td>
					<td>R$ {{ money2(parcela.valor_atualizado_com_desconto) }}</td>
				</tr>
				<!--                <tr>-->
				<!--                    <th/>-->
				<!--                    <th/>-->
				<!--                    <th>Total</th>-->
				<!--                    <th>R$ 0,00</th>-->
				<!--                </tr>-->
			</table>
		</div>
		<div v-if="divida.possuiLancamentosFuturos" class="infos-row">
			<h4>Parcelas Futuras</h4>
			<div class="infos">
				<h6>Total lançamentos futuros</h6>
				<h2>R$ {{ money2(divida.vlrDebito) }}</h2>
			</div>
			<div class="box-buttons">
				<div style="width: 100%; padding-right: 10px">
					<ButtonDefault :color="parceiro ? parceiroConfig.estilo.corPrimaria : 'var(primaryColor)'" @click.native="showDetails = showDetails === true ? null : true" :secondaryColor="true" text="Detalhes" />
				</div>
			</div>
		</div>
		<div v-if="divida.possuiLancamentosFuturos && showDetails" class="infos-row parcelas-box">
			<table class="table-parcelas">
				<tr>
					<th>Parcelas futuras</th>
					<th>Nome Estabelecimento</th>
					<th>Data compra</th>
					<th>Valor</th>
				</tr>
				<tr v-for="parcela in divida.parcelasFuturas">
					<td>{{ parcela.numParcela }}</td>
					<td>{{ parcela.strNomeLojaCompra }}</td>
					<td>{{ correctDate(parcela.dtaCompra) }}</td>
					<td>R$ {{ money2(parcela.vlrParcelaCalculada) }}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import ButtonDefault from "../../../../components/buttons/ButtonDefault";
import moment from "moment";
import globalMethods from "../../../../mixins/globalMethods";
import { mapState, mapActions } from "vuex";
import PaymentOptionsDebit from "@/views/documentDebts/MyDebits/components/PaymentOptionsDebit";
export default {
	name: "DetailsDebit",
	components: { PaymentOptionsDebit, ButtonDefault },
	mixins: [globalMethods],
	props: ["divida"],
	data() {
		return {
			showDetails: null
		};
	},
	mounted() {
		this.action_salvar_etapa({
			pes_codigo: this.divida.pes_codigo,
			esn_fk_ets_codigo: 33,
			emp_codigo: this.parceiroConfig.emp_codigo,
			loj_codigo: this.divida.loj_codigo
		}).then((response) => {});
	},
	computed: {
		...mapState({
			parceiro: (state) => state.parceiro,
			parceiroConfig: (state) => state.parceiroConfig
		}),
		orderParelas() {
			return this.divida.parcelas.sort((a, b) => a.par_prestacao - b.par_prestacao);
		}
	},
	methods: {
		...mapActions(["action_salvar_etapa"]),
		correctDate(date) {
			return moment(date).format("DD/MM/YYYY");
		}
	}
};
</script>

<style scoped>
.containerDebitDetail {
	width: 100%;
	box-sizing: border-box;
	max-width: 750px;
	padding: 30px;
	background: var(--whiteColor);
	border-radius: 40px;
	box-shadow: 0 1px 2px rgba(3, 27, 78, 0.16);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-content: center;
	margin-bottom: 100px;
}

.header-debits {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	box-sizing: border-box;
	width: 100%;
	max-width: 750px;
	cursor: pointer;
}

h3 {
	margin-bottom: 30px;
	color: #031b4e;
	font-family: "Roboto Black";
	text-transform: uppercase;
	font-size: 16px;
	text-align: center;
}

.header-debits i {
	font-size: 48px;
	color: #031b4e;
}

.infos-row {
	margin: 10px 0;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
}

.infos {
	padding: 10px 20px;
}

.infos h6 {
	color: #5b6987;
	font-family: "Roboto";
	font-size: 11px;
	margin-bottom: 3px;
}

.infos h2 {
	color: #031b4e;
	font-family: "Roboto Black";
	font-size: 14px;
}

h4 {
	color: #031b4e;
	font-family: "Roboto Black";
	text-transform: uppercase;
	font-size: 16px;
	background: #f5f6fa;
	padding: 10px;
	flex: 1;
	text-align: center;
}

.table-parcelas {
	width: 100%;
	text-align: center;
}

.table-parcelas th {
	color: #031b4e;
	font-family: "Roboto Black";
	font-size: 14px;
	height: 50px;
}

tr:nth-child(even) {
	background-color: #f9f9f9;
}

.table-parcelas td {
	color: #5b6987;
	font-family: "Roboto";
	font-size: 14px;
	height: 30px;
}

.parcelas-box {
	max-height: 400px;
	overflow-y: auto;
}
</style>
